// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--bDpNY","image-col":"a10a3f92e9--image-col--DSEqh","title-link":"a10a3f92e9--title-link--et6Y9","photo-link":"a10a3f92e9--photo-link--hPKAr"};